import { render, staticRenderFns } from "./Gridswitch.vue?vue&type=template&id=9f0ef48a&scoped=true&"
import script from "./Gridswitch.vue?vue&type=script&lang=js&"
export * from "./Gridswitch.vue?vue&type=script&lang=js&"
import style0 from "./Gridswitch.vue?vue&type=style&index=0&id=9f0ef48a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0ef48a",
  null
  
)

export default component.exports